<script setup>
import {computed, onUnmounted, getCurrentInstance, set, del} from 'vue'

// 1. Setup Instance Access
const {proxy} = getCurrentInstance()
const store = proxy.$store
const route = proxy.$route

// 2. Computed
const formData = computed(() => store.state.odpReports.formData)

// 3. Logic (Formerly 'created')
const monthsAgo = route.query.monthsAgo || ''
set(formData.value, 'monthsAgo', monthsAgo)

// 4. Cleanup (Formerly 'destroyed')
onUnmounted(() => {
    del(formData.value, 'monthsAgo')
})
</script>

<template>
    <select
        required
        v-model="formData.monthsAgo"
        class="form-select form-select-sm"
        name="months_ago"
        oninvalid="this.setCustomValidity('Please select a date range')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Select&hellip;</option>
        <option
            v-for="(text, value) in { 1: '1 month', 3: '3 months', 6: '6 months', 12: '12 months', 24: '24 months' }"
            :key="value"
            :value="value"
        >
            {{ text }}
        </option>
    </select>
</template>